<h2 mat-dialog-title>Admin Set Ladder</h2>

<mat-dialog-content>

   <select [(ngModel)]="ladder">
      <option *ngFor="let l of ladders" [value]="l.ladderId">{{l.ladderId}} - {{l.name}}</option>
   </select>
</mat-dialog-content>

<mat-dialog-actions style="float: right;">
   <a href="#" (click)="cancel($event)">Cancel</a>
   &nbsp;&nbsp;
   <button class="" (click)="save()">Save</button>
</mat-dialog-actions>